import React from "react";

const styles = require("./styles.module.scss");

export type LabeledValueProps = {
  heading: string;
  subheading?: string;
};

const LabeledValue: React.FC<LabeledValueProps> = ({
  heading,
  subheading = "",
}: LabeledValueProps) => {
  return (
    <div className={styles.labeledHeading}>
      <h3 className={styles.subheading}>
        {subheading && <span>{subheading}</span>}

        {/* If subheading isn't provided, create an empty div to keep consistent layout */}
        {!subheading && <span>&nbsp;</span>}
      </h3>
      <h2 className={styles.heading}>{heading}</h2>
    </div>
  );
};

export default LabeledValue;
